import { GameName } from 'constants/difficulty';
import { KingImages } from 'constants/tutorialKingImages';
import { SolitaireGame } from 'game/SolitaireGame';

const moves = [
    { cards: ['23'], target: '33', blockStockPile: true }, //
    { cards: ['A3'], target: '23', blockStockPile: true }, //
    { cards: ['33', '23', 'A3'], target: '43', blockStockPile: true }, //
    {
        cards: [],
        blockStockPile: true,
        target: '',
        freePlay: true,
        freePlayCondition: (game: SolitaireGame) => {
            const hiddenColumns = game.columns.filter((c) => c.hasHiddenCards).length;
            return !hiddenColumns && game.foundations.filter((f) => f.isComplete).length === 7;
        },
    },
    {
        cards: [],
        target: '',
        freePlay: true,
        freePlayCondition: (game) => {
            return game.stockPile.cards.length === 0; // No cards left in the stockpile
        },
    },
    {
        cards: [],
        target: '',
        freePlay: true,
        freePlayCondition: () => {
            return false;
        },
    },
    //
];
const contentKeys = [
    { king: KingImages.RIGHT_BLACK_THREE, contentKey: 'spiderTutorialStep1' }, //
    { king: KingImages.RIGHT_BLACK_THREE, contentKey: 'spiderTutorialStep1' },
    { king: KingImages.LEFT_BLACK_RIGHT_BLACK, contentKey: 'spiderTutorialStep2' },
    { king: KingImages.HANDS_FORWARD, contentKey: 'spiderTutorialStep3' },
    { king: KingImages.LEFT_BLUE, contentKey: 'spiderTutorialStep4' },
    { king: KingImages.HANDS_UP, contentKey: 'spiderTutorialStep5' },
];
const step = {
    gameId: 'spider_tutorial_step_1',
    columns: [
        [{ code: '63', visible: true }],
        [{ code: '73', visible: true }],
        [{ code: 'J3', visible: true }],
        [{ code: 'T3', visible: true }],
        [{ code: 'Q3', visible: true }],
        [{ code: 'K3', visible: true }],
        [{ code: '93', visible: true }],
        [
            { code: '43', visible: false },
            { code: '23', visible: true },
        ],
        [
            { code: 'K3', visible: false },
            { code: '53', visible: false },
            { code: '33', visible: true },
        ],
        [
            { code: '53', visible: false },
            { code: 'T3', visible: false },
            { code: '83', visible: false },
            { code: 'A3', visible: true },
        ],
    ],
    foundation: [
        [
            { code: 'A3', visible: true }, //
            { code: '23', visible: true }, //
            { code: '33', visible: true }, //
            { code: '43', visible: true }, //
            { code: '53', visible: true }, //
            { code: '63', visible: true }, //
            { code: '73', visible: true }, //
            { code: '83', visible: true }, //
            { code: '93', visible: true }, //
            { code: 'T3', visible: true }, //
            { code: 'J3', visible: true }, //
            { code: 'Q3', visible: true }, //
            { code: 'K3', visible: true }, //
        ],
        [
            { code: 'A3', visible: true }, //
            { code: '23', visible: true }, //
            { code: '33', visible: true }, //
            { code: '43', visible: true }, //
            { code: '53', visible: true }, //
            { code: '63', visible: true }, //
            { code: '73', visible: true }, //
            { code: '83', visible: true }, //
            { code: '93', visible: true }, //
            { code: 'T3', visible: true }, //
            { code: 'J3', visible: true }, //
            { code: 'Q3', visible: true }, //
            { code: 'K3', visible: true }, //
        ],
        [
            { code: 'A3', visible: true }, //
            { code: '23', visible: true }, //
            { code: '33', visible: true }, //
            { code: '43', visible: true }, //
            { code: '53', visible: true }, //
            { code: '63', visible: true }, //
            { code: '73', visible: true }, //
            { code: '83', visible: true }, //
            { code: '93', visible: true }, //
            { code: 'T3', visible: true }, //
            { code: 'J3', visible: true }, //
            { code: 'Q3', visible: true }, //
            { code: 'K3', visible: true }, //
        ],
        [
            { code: 'A3', visible: true }, //
            { code: '23', visible: true }, //
            { code: '33', visible: true }, //
            { code: '43', visible: true }, //
            { code: '53', visible: true }, //
            { code: '63', visible: true }, //
            { code: '73', visible: true }, //
            { code: '83', visible: true }, //
            { code: '93', visible: true }, //
            { code: 'T3', visible: true }, //
            { code: 'J3', visible: true }, //
            { code: 'Q3', visible: true }, //
            { code: 'K3', visible: true }, //
        ],
        [
            { code: 'A3', visible: true }, //
            { code: '23', visible: true }, //
            { code: '33', visible: true }, //
            { code: '43', visible: true }, //
            { code: '53', visible: true }, //
            { code: '63', visible: true }, //
            { code: '73', visible: true }, //
            { code: '83', visible: true }, //
            { code: '93', visible: true }, //
            { code: 'T3', visible: true }, //
            { code: 'J3', visible: true }, //
            { code: 'Q3', visible: true }, //
            { code: 'K3', visible: true }, //
        ],
        [
            { code: 'A3', visible: true }, //
            { code: '23', visible: true }, //
            { code: '33', visible: true }, //
            { code: '43', visible: true }, //
            { code: '53', visible: true }, //
            { code: '63', visible: true }, //
            { code: '73', visible: true }, //
            { code: '83', visible: true }, //
            { code: '93', visible: true }, //
            { code: 'T3', visible: true }, //
            { code: 'J3', visible: true }, //
            { code: 'Q3', visible: true }, //
            { code: 'K3', visible: true }, //
        ],

        [],
        [],
    ],
    name: GameName.SPIDER,
    movesCount: 0,
    moves: [],
    attempts: 0,
    score: 0,
    time: 0,
    wastePile: [],
    stockpile: [
        { code: 'Q3', visible: false },
        { code: '23', visible: false },
        { code: '33', visible: false },
        { code: '63', visible: false },
        { code: '73', visible: false },
        { code: '83', visible: false },
        { code: 'J3', visible: false },
        { code: 'A3', visible: false },
        { code: '43', visible: false },
        { code: '93', visible: false },
    ],
};

export default { step, moves, contentKeys };
